export default "__VITE_ASSET__D$$OmeKV__"